import useFetchObjects from "../../api/useFetchObjects";

const useBookDetails = (bookId) => {
  // Get token from localStorage
  const token = localStorage.getItem("token");

  return useFetchObjects(
    ["book-details", bookId],
    `books/${bookId}/`,
    token ? token : null,
    { refetchOnWindowFocus: false, enabled: !!bookId },
  );
};

export default useBookDetails;
